<template>
  <div class="bg-light container-main-parent pb-sm-0 h-100 d-flex flex-column">
    <parent-header />
    <div
      class="home-parent-cards-list d-flex flex-column w-100 min-h-100 scrollable-container p-3 mb-5"
    >
      <parent-card
        v-for="element in mainActions"
        :key="element.id"
        :cardInfo="{ title: element.title, brand: element.brand }"
        :url="element.router"
        :cardStyles="{
          ...element.cardStyles,
          customClass: 'w-100 h-5 flex-fill',
        }"
      />
    </div>
  </div>
</template>
<script>
import parentCard from '@/components/main/mainParentCard.vue';
import parentHeader from '@/components/main/mainParentHeader.vue';
import { mainActions } from '@/utils/parent.js';
import { mapGetters } from 'vuex';
export default {
  components: {
    parentCard,
    parentHeader,
  },
  data() {
    return {
      mainActions: mainActions,
    };
  },
  computed: {
    ...mapGetters('user', ['getUserName']),
  },
  mounted() {},
};
</script>
<style scoped lang="scss">
.home-parent-cards-list {
  flex: 1;
  gap: 0.8rem;
  background: transparent linear-gradient(305deg, #f2cb8a19 0%, #e9d09619 49%, #5af2eb19 100%) 0% 0%
    no-repeat padding-box;
  .home-parent-cards-list-content {
    height: fit-content;
  }
}

.container-main-parent{
  padding-bottom: 58rem;
}
.min-h-100 {
  min-height: 100%;
}
</style>
